import { normalizePlanSlug } from '@/lib/planLimits';

export type CheckoutPlanSlug = 'basic' | 'pro';

export function parseCheckoutPlan(value?: string | null): CheckoutPlanSlug | null {
  const normalized = normalizePlanSlug(value);
  if (normalized === 'basic' || normalized === 'pro') {
    return normalized;
  }
  return null;
}

export function buildPostAuthRedirect(plan: CheckoutPlanSlug | null, customRedirect?: string | null): string {
  if (customRedirect && customRedirect.startsWith('/')) {
    return customRedirect;
  }
  if (!plan) {
    return '/dashboard';
  }
  return `/billing?intent=checkout&plan=${plan}`;
}

export function withCheckoutPlanLink(href: string, plan: CheckoutPlanSlug | null): string {
  if (!plan) {
    return href;
  }

  const separator = href.includes('?') ? '&' : '?';
  return `${href}${separator}plan=${plan}`;
}
